import Component from "../../lib/component";
import iconDragHandle from './assets/icon__drag_handle.svg';

export const CsDragHandleConfig = {
    componentTypeKey: 'CsDragHandle',
    baseHtmlClass: 'cs_bubble__drag_handle',
    selector: '.cs_bubble__drag_handle',
}

export class CsDragHandle extends Component {

    static createDragHandle(csBubble) {
        let element = Component.createElement(CsDragHandleConfig.baseHtmlClass);
        const svgElement = new DOMParser().parseFromString(iconDragHandle, "image/svg+xml").documentElement;
        element.appendChild(svgElement);

        csBubble.element.appendChild(element);
        return new CsDragHandle(element, csBubble);
    }

    constructor(id_or_element, csBubble) {
        super({
            element: id_or_element,
            config: CsDragHandleConfig
        });

        this.csBubble = csBubble;
    }
}